export const API_URL = window.location.host === 'admin.esqque.com' ? 'https://api.esqque.com/' : 'http://127.0.0.1:8080/';